import type { IMetadataRepository } from '../repositories/IMetadataRepository.js';

interface Deps { metadataRepository: IMetadataRepository; }
export function createAdoptMetadataUseCase({ metadataRepository }: Deps) {
  return function adoptMetadata(args: { projectId: string; metadataId: string }): Promise<void> {
    return metadataRepository.adopt(args.projectId, args.metadataId);
  };
}

export function createUnadoptMetadataUseCase({ metadataRepository }: Deps) {
  return function unadoptMetadata(args: { projectId: string; metadataId: string }): Promise<void> {
    return metadataRepository.unadopt(args.projectId, args.metadataId);
  };
}

export function createUpdateAdoptionUseCase({ metadataRepository }: Deps) {
  return function updateAdoption(args: { projectId: string; metadataId: string; displayName: string | null }): Promise<void> {
    return metadataRepository.updateAdoption(args.projectId, args.metadataId, args.displayName);
  };
}
